import { render, staticRenderFns } from "./CostosServicios.vue?vue&type=template&id=91bf6544&scoped=true&"
import script from "./CostosServicios.vue?vue&type=script&lang=js&"
export * from "./CostosServicios.vue?vue&type=script&lang=js&"
import style0 from "./CostosServicios.vue?vue&type=style&index=0&id=91bf6544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bf6544",
  null
  
)

export default component.exports